var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { useState, useEffect, memo } from "react";
import { constants, selectors, functions, useTranslationValue, // @ts-ignore
 } from "paul-core-package";
import { EnergySavingHeader } from "./EnergySavingHeader";
import { stylesOverrides } from "../../../constants";
import { getAPIEnergySavingData } from "../../../api";
import { getComparisonPercentage } from "../../../helpers/getComparisonPercentage";
import { EnergySavingItem } from "./EnergySavingItem";
var TRANSLATIONS = {
    COMPARING_TWO_VALUES_TITLE: "COMPARING_TWO_VALUES_TITLE",
    COMPARING_TWO_VALUES_PERCENTAGE_TITLE: "COMPARING_TWO_VALUES_PERCENTAGE_TITLE",
    REFERENCE_VALUE_TITLE: "REFERENCE_VALUE_TITLE",
    FOCUS_VALUE_TITLE: "FOCUS_VALUE_TITLE",
    EQUIPMENTS_ENERGY_SAVING_TITLE: "EQUIPMENTS_ENERGY_SAVING_TITLE",
    DAILY_EQUIPMENTS_ENERGY_SAVING_TITLE: "DAILY_EQUIPMENTS_ENERGY_SAVING_TITLE",
    ENERGY_SAVING_SUBTITLE: "ENERGY_SAVING_SUBTITLE",
    ENERGY_SAVING_DAILY_SUBTITLE: "ENERGY_SAVING_DAILY_SUBTITLE",
};
var METRIC_UNIT = "kWh";
/** @todo inject store and move fetching data logic to redux flow  - required */
/** @todo investigate and fix translations issue, looks like data mutates and hook not rerender component, remove unnecessary translations dependency  - required */
/** @todo investigate issue with core types definition and delete ts-ignore comments  - optional */
/** @todo fix @ts-ignore with typing  - optional */
var comparingTwoValuesDefaultData = {
    headlineTitle: "",
    percentageTitle: "",
    referenceValueTitle: "",
    focusValueTitle: "",
    referenceValueValue: 0,
    focusValueValue: 0,
};
export var EnergySaving = memo(function () {
    var _a;
    var devicesById = useSelector(selectors.selectDevicesById);
    var htgHxEntities = useSelector(selectors.selectHtgHxEntities);
    var activeSiteId = useSelector(selectors.selectActiveSiteId); // || "ncEXGfxURxiJ_Ibfns7niA";
    var energyValvesData = Object.values(devicesById).filter(function (device) {
        return functions.getDisplayClassification(device.thingProductDisplayClassification) === constants.sensorTypes.energyValve;
    });
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    var tV = useTranslationValue();
    var translationValues = useSelector(selectors.getTranslationsValues);
    var units = (_a = translationValues === null || translationValues === void 0 ? void 0 : translationValues.Default) === null || _a === void 0 ? void 0 : _a.unit;
    var prefUrl = useSelector(selectors.getUrls).api;
    var token = useSelector(selectors.getToken);
    var _b = useState([]), energySavingData = _b[0], setEnergySavingData = _b[1];
    var _c = useState(false), isEnergySavingDataLoaded = _c[0], setIsEnergySavingDataLoaded = _c[1];
    var _d = useState(comparingTwoValuesDefaultData), comparingTwoValuesData = _d[0], setComparingTwoValuesData = _d[1];
    var _e = useState([]), metricRows = _e[0], setMetricRows = _e[1];
    var getValue = function (key) {
        return energySavingData.reduce(function (accumulator, energyValveData) {
            return accumulator + Number(energyValveData[key]);
        }, 0);
    };
    useEffect(function () {
        var getEnergySavingData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, dataPromise, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!prefUrl ||
                            !token ||
                            !activeSiteId ||
                            !Object.keys(devicesById).length ||
                            Object.keys(energySavingData).length ||
                            !energyValvesData.length ||
                            isEnergySavingDataLoaded) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        setIsEnergySavingDataLoaded(true);
                        payload = {
                            equipmentIds: (htgHxEntities === null || htgHxEntities === void 0 ? void 0 : htgHxEntities.ids) || [],
                        };
                        return [4 /*yield*/, getAPIEnergySavingData({
                                prefUrl: prefUrl,
                                token: token,
                                payload: payload,
                            })];
                    case 2:
                        dataPromise = _a.sent();
                        return [4 /*yield*/, dataPromise.json()];
                    case 3:
                        data = _a.sent();
                        setEnergySavingData(data);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        setIsEnergySavingDataLoaded(false);
                        functions.toastMessageCreator("Error", "Something went wrong during fetching energy saving data");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        getEnergySavingData();
    }, [
        activeSiteId,
        devicesById,
        token,
        prefUrl,
        energySavingData,
        energyValvesData,
    ]);
    useEffect(function () {
        var getTranslationString = function (translationKey) {
            return tI[translationKey] ? tI[translationKey].toString() : "";
        };
        var headlineTitle = getTranslationString(TRANSLATIONS.COMPARING_TWO_VALUES_TITLE);
        var percentageTitle = getTranslationString(TRANSLATIONS.COMPARING_TWO_VALUES_PERCENTAGE_TITLE);
        var referenceValueTitle = getTranslationString(TRANSLATIONS.REFERENCE_VALUE_TITLE);
        var focusValueTitle = getTranslationString(TRANSLATIONS.FOCUS_VALUE_TITLE);
        var getUpdatedEnergySavingData = function (referenceValueValue, focusValueValue) {
            return {
                headlineTitle: headlineTitle,
                percentageTitle: percentageTitle,
                referenceValueTitle: referenceValueTitle,
                focusValueTitle: focusValueTitle,
                focusValueUnit: METRIC_UNIT,
                referenceValueUnit: METRIC_UNIT,
                referenceValueValue: referenceValueValue,
                focusValueValue: focusValueValue,
            };
        };
        var getMetricRows = function (consumptionWithoutPAUL, consumptionWithPAUL) {
            return energySavingData.reduce(function (accumulator, energyValveData) {
                var currentEnergyValveData = energyValvesData.find(function (energyValve) {
                    return energyValve.equipmentId === (energyValveData === null || energyValveData === void 0 ? void 0 : energyValveData.unitName);
                });
                var energyValveConsumption = Number(energyValveData === null || energyValveData === void 0 ? void 0 : energyValveData[consumptionWithoutPAUL]) || 0;
                var energyValveConsumptionWithPaul = Number(energyValveData === null || energyValveData === void 0 ? void 0 : energyValveData[consumptionWithPAUL]) || 0;
                var energyValveSaving = getComparisonPercentage(energyValveConsumption, energyValveConsumptionWithPaul);
                var row = {
                    id: energyValveData === null || energyValveData === void 0 ? void 0 : energyValveData.unitName,
                    unit: tV(currentEnergyValveData === null || currentEnergyValveData === void 0 ? void 0 : currentEnergyValveData.equipmentName) || "-",
                    saving: energyValveSaving ? "".concat(energyValveSaving.toFixed(1), "%") : "-",
                    referenceConsumption: energyValveConsumption
                        ? "".concat(energyValveConsumption.toFixed(1), " ").concat(METRIC_UNIT)
                        : "-",
                    focusConsumption: energyValveConsumptionWithPaul
                        ? "".concat(energyValveConsumptionWithPaul.toFixed(1), " ").concat(METRIC_UNIT)
                        : "-",
                };
                accumulator.push(row);
                return accumulator;
            }, []);
        };
        var referenceValueValue = getValue("consumptionWithoutPAUL");
        var focusValueValue = getValue("consumptionWithPAUL");
        var updatedEnergySavingData = getUpdatedEnergySavingData(referenceValueValue, focusValueValue);
        var newMetricRows = getMetricRows("consumptionWithoutPAUL", "consumptionWithPAUL");
        setMetricRows(newMetricRows);
        setComparingTwoValuesData(updatedEnergySavingData);
    }, [
        energySavingData,
        units,
        tI[TRANSLATIONS.COMPARING_TWO_VALUES_TITLE],
        tI[TRANSLATIONS.COMPARING_TWO_VALUES_PERCENTAGE_TITLE],
        tI[TRANSLATIONS.REFERENCE_VALUE_TITLE],
        tI[TRANSLATIONS.FOCUS_VALUE_TITLE],
    ]);
    return (_jsxs(Box, __assign({ sx: stylesOverrides, mb: 10 }, { children: [_jsx(EnergySavingHeader, {}), _jsx(Box, __assign({ mb: 5 }, { children: _jsx(EnergySavingItem, { titleTransKey: TRANSLATIONS.ENERGY_SAVING_SUBTITLE, comparingTwoValuesData: comparingTwoValuesData, metricRows: metricRows, metricsTableTitleTransKey: TRANSLATIONS.EQUIPMENTS_ENERGY_SAVING_TITLE }) }))] })));
});
